export function PlayerSearchCardSkeleton() {
  return (
    <div className='flex animate-pulse flex-col gap-2 rounded-lg border border-gray-200 bg-white p-4 text-sm shadow-sm'>
      <div className='h-4 w-2/5 rounded bg-gray-300' />
      <div className='h-4 w-3/5 rounded bg-gray-300' />
      <div className='h-4 w-1/6 rounded bg-gray-300' />
    </div>
  );
}
